<div class="snake">
    <img [src]="snake.svg"/>
</div>
